"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_ROOM_OCCUPANCY = exports.DEFAULT_CONTEXTUAL_PRODUCT_ID = exports.ASYNC_DATA_KEYS = exports.PAX_TRANSLATION_KEYS = exports.ICONS = exports.LOCATION_TYPES = exports.USW_COMPONENT_TYPES = exports.SSR_DATA = exports.DEFAULT_ENDPOINT = exports.JWT_HASH = void 0;
var USW_COMPONENT_TYPES = {
  HERO_BANNER: 'heroBanner',
  PLACEPICKER: 'placepicker',
  DATEPICKER: 'datepicker',
  MULTI_ROOM_SELECT: 'multi_room_select',
  PAX_COUNTER: 'passenger_counter',
  DROPDOWN: 'dropdown',
  LINK: 'link',
  CHECKBOX: 'checkbox',
  BUTTON: 'button'
};
exports.USW_COMPONENT_TYPES = USW_COMPONENT_TYPES;
var LOCATION_TYPES = {
  AIR_PORT: 'airport',
  REGION: 'region',
  CITY: 'city',
  LANDMARK: 'landmark',
  NEIGHBORHOOD: 'neighborhood',
  HOTEL: 'hotel'
};
exports.LOCATION_TYPES = LOCATION_TYPES;
var ICONS = {
  FLIGHT_ICON: 'FlightIcon',
  LOCATION_ICON: 'LocationOnIcon'
};
exports.ICONS = ICONS;
var PAX_TRANSLATION_KEYS = {
  ADULT: 'adultSingle',
  ADULT_AGE_LIMIT: 'adultAgeLimit',
  CHILD: 'childSingle',
  CHILD_AGE_LIMIT: 'childAgeLimit',
  INFANT: 'infantSingle',
  INFANT_AGE_LIMIT: 'infantAgeLimit'
};
exports.PAX_TRANSLATION_KEYS = PAX_TRANSLATION_KEYS;
var ASYNC_DATA_KEYS = {
  FEATURE_FLAG: 'feature_flag',
  ORIGIN_STATIONS: 'originStationsData',
  SEARCH_DEEP_LINK: 'searchDeepLink',
  DATA_VISOR: 'dataVisor',
  NEAREST_AIRPORT: 'nearest_airport',
  DESTINATION_STATIONS: 'destination_stations',
  BASE_CURRENCY: 'baseCurrency',
  CALENDAR_DATA: 'calendarDateFormatData'
};
exports.ASYNC_DATA_KEYS = ASYNC_DATA_KEYS;
var SSR_DATA = {
  synonyms: [{
    name: 'ALGO_ONE',
    value: ['SSI5', 'SPAK', 'SMD7', 'SKLB', 'SXAI']
  }, {
    name: 'ALGO_TWO',
    value: ['SRX5', 'SRDJ', 'SLAK', 'SKD7', 'SBZ2']
  }, {
    name: 'ALGO_THREE',
    value: ['SPGR', 'SMDJ', 'SMXT', 'SZQZ', 'SLXT']
  }, {
    name: 'ALGO_FOUR',
    value: ['SSXT', 'SLZ2', 'SRXT', 'SAI5', 'SBI5']
  }, {
    name: 'ALGO_FIVE',
    value: ['SLD7', 'SQXJ', 'SOXT', 'SBFD', 'SYXT']
  }, {
    name: 'ALGO_SIX',
    value: ['SLUM', 'SQAI', 'SORM', 'SBOH', 'SYAM']
  }],
  api_data: [{
    source: 'booking',
    id: 'sdlkd2l3'
  }, {
    source: 'details',
    id: 'eue3kds'
  }, {
    source: 'checkout',
    id: 'wxesdumi'
  }, {
    source: 'search',
    id: 'xmncx278'
  }, {
    source: 'smartfill',
    id: 'wiuwejk2'
  }]
};
exports.SSR_DATA = SSR_DATA;
var JWT_HASH = '906a14a4c039ea4af65874742638ddae5c3ec9c6bbc9026eea35f00f';
exports.JWT_HASH = JWT_HASH;
var DEFAULT_ENDPOINT = 'smartfill';
exports.DEFAULT_ENDPOINT = DEFAULT_ENDPOINT;
var DEFAULT_CONTEXTUAL_PRODUCT_ID = 'hotels';
exports.DEFAULT_CONTEXTUAL_PRODUCT_ID = DEFAULT_CONTEXTUAL_PRODUCT_ID;
var DEFAULT_ROOM_OCCUPANCY = [{
  adult: 2,
  child: 0,
  infant: 0
}];
exports.DEFAULT_ROOM_OCCUPANCY = DEFAULT_ROOM_OCCUPANCY;